<template>
    <div>
      <div class="w-100 h-100">
        <Nav :rolname="rolname" />
      </div>
      <div class="content h-100" style="background: white">
        <Home
          v-if="page == 'home'"
          @changePage="changePage"
          @mtdBackCampus="mtdBackCampus"
        />
        <Pago v-if="page == 'pago'" @returnHome="returnHome" />
      </div>
      <div class="footer">
        <FooterVue @changePage="changePage" :pageView="page" />
      </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    import Nav from "../../components/Facturacion/Nav.vue";
    import FooterVue from "../../components/Facturacion/Footer.vue";
    import Home from "../../components/Facturacion/Home.vue";
    import Pago from "../../components/Facturacion/pages/Pago.vue";

    export default {
    name: "FacturacionView",
    components: {
        Nav,
        FooterVue,
        Home,
        Pago
    },
    data () {
        return {
          prefix: 'facturacion',
          page:'home',
        }
    },
    props: {
        rolname: String,
    },
    created () {
        this.rol_name = this.rolname;
    },
    methods: {
        ...mapActions(['get', 'post']),
        changePage: function (page) {
        this.page = page;
        },
        returnHome: function () {
        this.page = "home";
        },
        mtdBackCampus: function () {
        this.$emit("mtdBackCampus");
        },
        mtdBackRol: function () {
        this.$emit("mtdBackRol");
        },
    }
    
    }
</script>
  